import { FormikProps } from 'formik';
import { Col, Form, Row } from 'antd';
import { MTextArea } from '@Components/Base';

const DEFAULT_ROWS = 2;

interface TextAreaProps<T> {
  formik: FormikProps<T>;
  formikKey: string;
  placeholder?: string;
  maxLength?: number;
  rows?: number;
}

const TextArea = <T,>({
  formik,
  formikKey,
  placeholder,
  maxLength,
  rows,
}: TextAreaProps<T>): JSX.Element => {
  const value = formik.getFieldMeta(formikKey).value as string;

  return (
    <Row>
      <Col span={24}>
        <Form.Item>
          <MTextArea
            value={value}
            onChange={(e) => {
              formik.setFieldValue(formikKey, e.target.value);
            }}
            rows={rows || DEFAULT_ROWS}
            showCount
            maxLength={maxLength}
            placeholder={placeholder}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default TextArea;
